import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { GET_LOCAL_SAMPLE_DETAILS } from "../queryKeys";
import { GET_SAMPLE_ANALYSIS_STATUS_QUERY_KEY } from "../components/analysistable/integrations_analysis_table/IntegrationsAnalysisTable";
import { useGetMergedRlcsReport } from "../components/rlcloudsandbox/hooks/useGetMergedRlcsReport";

const useRefetchSampleData = (hash?: string) => {
  const queryClient = useQueryClient();

  const { mergedReportData } = useGetMergedRlcsReport(hash ?? "");

  useEffect(() => {
    if (mergedReportData?.refetch_sample_data) {
      queryClient.invalidateQueries({
        queryKey: [GET_LOCAL_SAMPLE_DETAILS]
      });
      queryClient.invalidateQueries({
        queryKey: [GET_SAMPLE_ANALYSIS_STATUS_QUERY_KEY, hash]
      });
    }
  }, [hash, mergedReportData, queryClient]);
};

export default useRefetchSampleData;
